import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SingleTimeFieldFormModalData } from 'src/app/interface/components/forms/single-time-field-form.interface';
import {
  availabilityApiTimeTo12hLabel,
  reservationScheduleTimeLabelToApi24h,
} from 'src/app/pages/areas/new-area-v2/mappers/reservation-availability-time.util';

@Component({
  selector: 'common-single-time-field-form-modal',
  templateUrl: './single-time-field-form-modal.component.html',
  styleUrls: ['./single-time-field-form-modal.component.scss'],
})
export class SingleTimeFieldFormModalComponent implements OnInit {
  @Input() title: string = '';
  @Input() inputLabel: string = '';
  @Input() currentValue: string = '';
  @Input() labelButtonCancel: string = 'modal.button.cancel';
  @Input() labelButtonSave: string = 'modal.button.save';
  @Input() minuteStep: number = 15;
  @Input() loading: boolean = false;

  @Output() save = new EventEmitter<string>();
  @Output() cancel = new EventEmitter<void>();

  form: FormGroup;
  timeControl: FormControl;

  constructor(
    private readonly _fb: FormBuilder,
    private readonly _matDialogRef: MatDialogRef<SingleTimeFieldFormModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SingleTimeFieldFormModalData,
  ) {
    if (this.data) {
      this.title = this.data.title || this.title;
      this.inputLabel = this.data.inputLabel || this.inputLabel;
      this.currentValue = this.data.currentValue || this.currentValue;
      this.labelButtonCancel = this.data.labelButtonCancel || this.labelButtonCancel;
      this.labelButtonSave = this.data.labelButtonSave || this.labelButtonSave;
      this.minuteStep = this.data.minuteStep ?? this.minuteStep;
    }

    this.timeControl = new FormControl('', [Validators.required]);
    this.form = this._fb.group({ time: this.timeControl });
  }

  ngOnInit(): void {
    // Convert from backend HH:mm to 12h label expected by `app-time-input-field`.
    const initial24 = String(this.currentValue ?? '').trim();
    const initial12 = initial24 ? availabilityApiTimeTo12hLabel(initial24) : '';
    this.timeControl.setValue(initial12, { emitEvent: false });
  }

  onEventClose(): void {
    this._matDialogRef.close();
  }

  onEventCancel(): void {
    this.cancel.emit();
    this._matDialogRef.close();
  }

  onEventSave(): void {
    if (!this.form.valid) return;
    const raw = String(this.timeControl.value ?? '').trim();
    const hhmm = reservationScheduleTimeLabelToApi24h(raw);
    this.save.emit(hhmm);
    this._matDialogRef.close(hhmm);
  }
}

